import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(() => ({
  UploadProgramFileLogo: {
    width: '100%',
    height: '3em',
    padding: '1em 1em 0em 1em',
  },
  ProgramFileLogo: {
    width: '100%',
  },
}))

export { useStyles }
